import React from 'react'
import Image from '@/components/Image'
import NormalButton from '../Button/normal'

interface ScheduleReminderProps {
  iconUrl: string;
  title: string;
  description: React.ReactNode;
  buttonText: string;
  onButtonClick: () => void;
}

const ScheduleReminder = ({ iconUrl, title, description, buttonText, onButtonClick }: ScheduleReminderProps) => {
  
  return (
    <div className='flex flex-col gap-2 items-center'>
        <Image className='w-fit h-40 object-cover -mt-25' src={iconUrl} alt="schedule-reminder" width={100} height={100} />
        <span className='text-lg text-black font-bold'>{title}</span>
        <span className='max-w-80 text-sm text-black text-center'>{description}</span>
        <NormalButton
          onClick={onButtonClick}
        >
          <span className="text-sm">{buttonText}</span>
        </NormalButton>
    </div>
  )
}

export default ScheduleReminder
